import React from 'react';

import './Disclaimer.scss';

function Disclaimer({ title, children }) {
  if (!children) {
    return null;
  }

  return (
    <div className="mn_instoreDisclaimer">
      {title && <div className="mn_title">{title}</div>}
      {children}
    </div>
  );
}

export default Disclaimer;
